<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Versión Por Revisión</h1>
</div>


<!--&================= CONTAINER TABLE =================&-->
<div class="container-global-components ConLA">
  <div class="Table-container-Global Local-LA">
    <table>
      <thead>

        <ng-container *ngFor="let Header of HeadersLA;let i= index">

          <ng-container *ngIf="Header.Key_Header ==='VER'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='NAF'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='CODEF'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='DES'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header === 'ANNEX'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='DAC'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='DAA'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='APP1'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='APP2'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='APP3'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

          <ng-container *ngIf="Header.Key_Header ==='APP4'">
            <th class="{{Header.Key_Header}}">{{Header.Name}}</th>
          </ng-container>

        </ng-container>

      </thead>
      <tbody>

        <tr>

          <td *ngFor="let Header of HeadersLA;let i = index">

            <ng-container *ngIf="Header.Key_Header ==='VER'">
              {{LastApprovedFIN.Revision_No}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header ==='NAF'">
              {{LastApprovedFIN.Name}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'ANNEX'">
              <div class="Container-Annexe">

                <button [disabled]="LastApprovedFIN.Annexes.length === 0"
                  (click)="Can_See_Modal_Annexe(LastApprovedFIN)"
                  class="Btn-Annexe {{Contain_Annexe(LastApprovedFIN.Annexes)}}">

                  <ng-container *ngIf="LastApprovedFIN.Annexes.length>0 && Load_Page">
                    <i class="fa-regular fa-paste"></i>
                  </ng-container>

                  <ng-container *ngIf="LastApprovedFIN.Annexes.length===0 && Load_Page">
                    <i class="fa-solid fa-question"></i>
                  </ng-container>

                  <div class="Tool-Tip T-Annexe {{Contain_Annexe(LastApprovedFIN.Annexes)}}">
                    {{Contain_Annexe_Text(LastApprovedFIN.Annexes)}}</div>
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'CODEF'">
              <div class="Description">

                <div class="Text-Description">
                  {{Cut_Code(LastApprovedFIN.Code)}}
                </div>

                <button (click)="See_Code(LastApprovedFIN.Code)" *ngIf="LastApprovedFIN.Code.length > 15"
                  class="Btn-Description">
                  <i class="fa-regular fa-file-lines"></i>
                  <div class="Tool-Tip T-Description">Ver Código</div>
                </button>

              </div>

            </ng-container>

            <ng-container *ngIf="Header.Key_Header ==='DES'">
              <div class="Description">

                <div class="Text-Description">
                  {{Cut_Purpose(LastApprovedFIN.Purpose)}}
                </div>

                <button (click)="See_Purpose(LastApprovedFIN.Purpose)" *ngIf="LastApprovedFIN.Purpose.length > 32"
                  class="Btn-Description">
                  <i class="fa-regular fa-file-lines"></i>
                  <div class="Tool-Tip T-Description">Ver Objetivo</div>
                </button>

              </div>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header ==='DAC'">
              {{DateFormat(LastApprovedFIN.Date_Created)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header ==='DAA'">
              {{DateFormat(LastApprovedFIN.Date_End)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header ==='APP1'">
              {{Get_Name_Approver(LastApprovedFIN.Approver1_Name)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header ==='APP2'">
              {{Get_Name_Approver(LastApprovedFIN.Approver2_Name)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header ==='APP3'">
              {{Get_Name_Approver(LastApprovedFIN.Approver3_Name)}}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header ==='APP4'">
              {{Get_Name_Approver(LastApprovedFIN.Approver4_Name)}}
            </ng-container>


          </td>

        </tr>

      </tbody>
    </table>
  </div>
  <button (click)="DownloadFile()" class="Btn-Download-Local-LA Btn-Download-Global" id="Btn-Download">
    <div class="Content-Download">
      <span class="Progress-Bar-Task" id="Progress-Bar-Task"></span>
      <span class="Btn-Text" id="Text-Btn">Descargar</span>
      <i class="fa-solid fa-cloud-arrow-down" id="Icon-Btn"></i>
    </div>
  </button>
</div>


<!---===================== MODAL FOR SEE ANNEXES =====================--->
<section class="Modal-Global" id="Modal-See-Annexe">
  <div class="wrapper">
    <div class="Pro-popup-See-Annexes1 popup">
      <div class="Pro-inside-See-Annexes1 popup-inside">
        <div class="Pro-backgrounds-See-Annexes1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-content-See-Annexes1 content">
        <button (click)="Modal_See_Annexe(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></button>
        <div class="Content-Top">
          <h2>Anexos</h2>
          <h4>Anexos de {{LastApprovedFIN.Name}}</h4>
        </div>

        <div class="Content-body">

          <div class="Container-Annexes Container-Annexes-See">
            <div class="Container-Card-Annexes">

              <div *ngFor="let Annexe of LastApprovedFIN.Annexes" class="Card-Annexes">

                <div class="Container-File">
                  <ng-container *ngFor="let icon of Icons_Image">
                    <div *ngIf="Annexe.Extension.toUpperCase()==icon.Extension.toUpperCase()">
                      <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                    </div>
                  </ng-container>
                  <div class="Name-Annexe">
                    {{CutNameFile(Annexe.Name,35)}}
                  </div>
                </div>

                <div class="Container-Buttons-Annexe">
                  <button (click)="Can_Download_Annexe(Annexe)" type="button" class="button-square">
                    <i class="fa-solid fa-download"></i>
                  </button>
                </div>


              </div>

            </div>
          </div>

          <div class="Container-Download-Annexe" id="Container-Download-Annexe">
            <div class="Container-progress-bar-Annexe">
              <span class="Progress-Bar-Annexe" id="Progress-Bar-Annexe"></span>
            </div>
          </div>

        </div>
        <div class="Content-Bottom Bottom-Modal-See-Annexe">
          <button (click)="Modal_See_Annexe(false)" class="Btn-Close-Modal ">
            <span>Cerrar</span>
          </button>

        </div>
      </div>

    </div>
  </div>
</section>


<!--&================= LOADER =================&-->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
